var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CheckPermission",
    {
      attrs: {
        "container-class": _vm.containerClass,
        permission: _vm.permission
      }
    },
    [
      _c("input", {
        ref: "file",
        staticClass: "d-none",
        attrs: { type: "file", accept: _vm.accept },
        on: {
          change: function($event) {
            return _vm.uploadFile($event)
          }
        }
      }),
      _vm.typeButton !== "small"
        ? _c(
            "b-button",
            {
              class: _vm.buttonClass,
              attrs: {
                variant: _vm.color,
                disabled: _vm.progress.enabled || _vm.disabled
              },
              on: {
                click: function($event) {
                  return _vm.$refs.file.click()
                }
              }
            },
            [_vm._t("default", [_vm._v(_vm._s(_vm.text))])],
            2
          )
        : _vm._e(),
      _vm.typeButton === "small"
        ? _c(
            "b-button",
            {
              class: _vm.buttonClass,
              attrs: {
                variant: _vm.color,
                disabled: _vm.progress.enabled || _vm.disabled,
                size: "sm"
              },
              on: {
                click: function($event) {
                  return _vm.$refs.file.click()
                }
              }
            },
            [
              _c("feather-icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover.left",
                    value: "Adjuntar documento",
                    expression: "'Adjuntar documento'",
                    modifiers: { hover: true, left: true }
                  }
                ],
                attrs: { icon: "PaperclipIcon" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.progress.enabled
        ? _c("vs-progress", {
            attrs: {
              percent: _vm.progress.percent,
              indeterminate: _vm.progress.indeterminate,
              color: _vm.color
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }